export function getDistance(value: number | null | undefined, unitSystem: "metric" | "imperial") {
  const units = unitSystem === "metric" ? "km" : "miles"
  if (!value) return `0 ${units}`
  const distance = unitSystem === "metric" ? value * 0.001 : value * 0.001 * 0.62137
  return `${parseFloat(distance.toFixed(2))} ${units}`
}
